module.exports = __webpack_public_path__ + "1b1aa32d9b5afab9371f16f35e42040e.svg";